<template>
  <div class="box1">
    <img src="../../../assets/coursePage/trainer/01-2.png"/>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
     
    };
  },
  computed: {
    
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;

  width: 100%;
  height: 812px;
  background: url("../../../assets/coursePage/trainer/01-1.png") center top no-repeat;
  background-size: contain;
 

  box-sizing: border-box;
  img{
    margin-top: 394px;
    width: 100%;
  }
   
}
</style>
